import { makeAutoObservable } from "mobx";
import { PDescription } from "./PDescription";
import { PModifierInstanceId } from "./PModifierInstanceId";
import { PPrice } from "./PPrice";
import { PTemporarilyUnavailableIngredients } from "./PTemporarilyUnavailableIngredients";
import { CreatorConfigValidation } from "./CreatorConfigValidation";
export class PModifierInstanceCreator {
    constructor(params) {
        this.instanceId = new PModifierInstanceId();
        this.domain = params.domain;
        this.modifierInstanceAvailabilityService =
            params.modifierInstanceAvailabilityService;
        this.modifierInstancePriceService = params.modifierInstancePriceService;
        this.modifierType = params.modifierType;
        this.localizationProvider = params.localizationProvider;
        this._sections = this.modifierType.sections.map((modifierItemSection) => params.pModifierSectionCreatorFactory.create({
            modifierItemSection,
            domain: params.domain,
            onChange: () => this.creatorConfigValidation.validate(),
        }));
        this.creatorConfigValidation = new CreatorConfigValidation({
            getUnavailabilityReasons: () => this.availability.unavailabilityReasons,
            minItems: params.modifierType.domain.minItems,
            maxItems: params.modifierType.domain.maxItems,
        });
        this._isEditorVisible = !this.isWrapping;
        makeAutoObservable(this);
    }
    get isVisible() {
        return this.sections.length > 0;
    }
    get isWrapping() {
        return this.domain.behaviour === "Wrapping";
    }
    get isEditable() {
        return this.domain.editability.isPossiblyEditable;
    }
    get isTogglingEditorPossible() {
        return this.isWrapping && this.isEditable;
    }
    get isEditorVisible() {
        return this.isEditable && this._isEditorVisible;
    }
    toggleEditor() {
        this._isEditorVisible = !this._isEditorVisible;
    }
    get typeId() {
        return this.domain.typeId;
    }
    get name() {
        return this.modifierType.name;
    }
    get sections() {
        return this._sections.filter((section) => section.isVisible);
    }
    get price() {
        const p = new PPrice(this.localizationProvider, this.modifierInstancePriceService.price(this.domain.modifierInstance).spectrum).priceValue;
        return p === null ? "" : ` (${p})`;
    }
    get availability() {
        return this.modifierInstanceAvailabilityService.availability(this.domain.modifierInstance);
    }
    get selectedItemsDescription() {
        return PDescription.modifier(this.domain.modifierInstance, this.modifierType);
    }
    get description() {
        return this.modifierType.description;
    }
    get displayMode() {
        return this.modifierType.displayMode;
    }
    get temporarilyUnavailableIngredients() {
        const itemInstanceCreators = this._sections.flatMap((modifierSection) => modifierSection.allItemCreators);
        return PTemporarilyUnavailableIngredients.fromInstanceCreators(this.modifierType, itemInstanceCreators);
    }
}
